import { stores } from "./flags";

const makeCountryAccounts = (productCountries, lang) => {
    const countries = Array(productCountries.length);
    productCountries.map((c, i) => {
        let store = stores.find((i) => i.name == c);
        let storeName = lang == "ar" ? store.ar.store : store.en.store;
        let country = {
            country: store.name,
            flag: store.flag,
            name: storeName
        };
        countries[i] = country;
    });
    return countries;
};

export default makeCountryAccounts;
